import { useState, useEffect } from "react";
import { useModal } from "../context/ModalContext";
import ModalComponent from "../components/ModalComponent";
// import SoftwareAuditModal from "../components/SoftwareAuditModal";

export default function TermsOfUse() {
  // const { showModal, handleClose } = useModal();

  useEffect(() => {
    document.title = "Terms Of Use - Plural Code Technologies";
  }, []);
  return (
    <div>
      <main className="wrapper">
        <section className="page-hero-sec administration-sec">
          <div className="container">
            <div className="page">
              <div className="translations-content-container">
                <div className="container">
                  <div
                    className="tab-content translations-content-item en visible"
                    id="en"
                  >
                    <h1 className="tc-primary head-font text-center pb-5">
                      Terms of Use
                    </h1>

                    <div className="terms-content">
                      <p
                        className="tc-primary fs-17 py-2"
                        style={{ textAlign: "justify" }}
                      >
                        <strong>Effective Date:</strong> May 1, 2025
                      </p>

                      <p
                        className="tc-primary fs-17 py-2"
                        style={{ textAlign: "justify" }}
                      >
                        Welcome to Plural Code Technologies{" "}
                        {/* <span className="fs-14">
                          (part of <b>Sarentu IT Solutions Pvt. Ltd.</b>)
                        </span> */}
                        ! These Terms of Use ("Terms") govern your access to and
                        use of our website and services related to webinar
                        registrations, including payment processing. By
                        accessing or using our site, you agree to be bound by
                        these Terms. If you do not agree, please do not use our
                        services.
                      </p>

                      <h2 className="tc-primary head-font py-3">
                        1. Use of Our Services
                      </h2>
                      <p
                        className="tc-primary fs-17 py-2"
                        style={{ textAlign: "justify" }}
                      >
                        You agree to:
                      </p>
                      <ul>
                        <li className="tc-primary fs-17 py-2">
                          Provide accurate and complete registration and payment
                          information
                        </li>
                        <li className="tc-primary fs-17 py-2">
                          Use our services only for lawful purposes
                        </li>
                        <li className="tc-primary fs-17 py-2">
                          Not attempt to disrupt or misuse the website or
                          webinar services
                        </li>
                      </ul>

                      <h2 className="tc-primary head-font py-3">
                        2. Webinar Registration & Payments
                      </h2>
                      <ul>
                        <li className="tc-primary fs-17 py-2">
                          All webinar registrations must be completed via our
                          official website
                        </li>
                        <li className="tc-primary fs-17 py-2">
                          Payment is required at the time of registration. We
                          accept credit/debit cards, UPI, and other digital
                          payment methods
                        </li>
                        <li className="tc-primary fs-17 py-2">
                          Registrations are confirmed only upon successful
                          payment and confirmation email
                        </li>
                      </ul>

                      <h2 className="tc-primary head-font py-3">
                        3. Cancellations & Refunds
                      </h2>
                      <h4 className="tc-primary head-font py-2">
                        Cancellation by You:
                      </h4>
                      <p
                        className="tc-primary fs-17 py-2"
                        style={{ textAlign: "justify" }}
                      >
                        Cancellations must be requested in writing at least 10
                        business days before the webinar. Refunds (if
                        applicable) will be processed within 7 business days,
                        minus any processing fees.
                      </p>

                      <h4 className="tc-primary head-font py-2">
                        Cancellation by Us:
                      </h4>
                      <p
                        className="tc-primary fs-17 py-2"
                        style={{ textAlign: "justify" }}
                      >
                        We reserve the right to cancel or reschedule any
                        webinar. In such cases, you will be offered a full
                        refund or the option to attend a future session.
                      </p>

                      <h2 className="tc-primary head-font py-3">
                        4. Intellectual Property
                      </h2>
                      <p
                        className="tc-primary fs-17 py-2"
                        style={{ textAlign: "justify" }}
                      >
                        All content shared during the webinar—including
                        presentations, recordings, and resources—is the property
                        of Plural Code Technologies{" "}
                        {/* <span className="fs-14">
                          (part of <b>Sarentu IT Solutions Pvt. Ltd.</b>)
                        </span> */}
                        {" "}
                        or its licensors. You may not reproduce, distribute, or
                        use this material without prior written consent.
                      </p>

                      <h2 className="tc-primary head-font py-3">
                        5. Limitation of Liability
                      </h2>
                      <p
                        className="tc-primary fs-17 py-2"
                        style={{ textAlign: "justify" }}
                      >
                        We are not liable for:
                      </p>
                      <ul>
                        <li className="tc-primary fs-17 py-2">
                          Technical issues preventing access to the webinar
                        </li>
                        <li className="tc-primary fs-17 py-2">
                          User error in registration or payment process
                        </li>
                        <li className="tc-primary fs-17 py-2">
                          Any indirect, incidental, or consequential damages
                          arising from your use of the site or webinar services
                        </li>
                      </ul>

                      <h2 className="tc-primary head-font py-3">6. Privacy</h2>
                      <p
                        className="tc-primary fs-17 py-2"
                        style={{ textAlign: "justify" }}
                      >
                        Your personal and payment information is handled in
                        accordance with our Privacy Policy. We do not store full
                        payment details on our servers.
                      </p>

                      <h2 className="tc-primary head-font py-3">
                        7. Changes to Terms
                      </h2>
                      <p
                        className="tc-primary fs-17 py-2"
                        style={{ textAlign: "justify" }}
                      >
                        We may update these Terms at any time. Continued use of
                        the site constitutes acceptance of the revised Terms.
                      </p>

                      <h2 className="tc-primary head-font py-3">8. Contact</h2>
                      <p
                        className="tc-primary fs-17 py-2"
                        style={{ textAlign: "justify" }}
                      >
                        For questions regarding these Terms, please contact us
                        at:
                      </p>
                      <ul>
                        <li className="tc-primary fs-17 py-2">
                          Email:{" "}
                          <a
                            href="mailto:info@pluralcode.com"
                            className="text-blue-600 hover:underline"
                          >
                            info@pluralcode.com
                          </a>
                        </li>
                        <li className="tc-primary fs-17 py-2">
                          Phone: +91-9958920231
                        </li>
                      </ul>

                      <h2 className="tc-primary head-font py-3">
                        9. Governing Law & Jurisdiction
                      </h2>
                      <p
                        className="tc-primary fs-17 py-2"
                        style={{ textAlign: "justify" }}
                      >
                        These Terms are governed by the laws of India. Any
                        disputes arising from or in connection with these Terms
                        shall be subject to the exclusive jurisdiction of the
                        courts located in Delhi, India.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* {showModal && (
        <SoftwareAuditModal handleClose={handleClose} showModal={showModal} />
      )} */}
    </div>
  );
}
